export const _LOAD_MODEL_ = 'Load:Ticket';
export const _SAVE_MODEL_ = 'Save:Ticket';
export const _RESET_MODEL_ = 'Reset:Ticket';
export const _LOAD_COMMENT_ = 'Load:TicketComment';
export const _DELETE_TICKET_ = 'Delete:Ticket';
export const _OPEN_CONFIRMATION_ = 'Confirmation:Open';

export const OPTIONS_CONFIRMATION_MODAL = {
  status: {
    callback: 'update',
    title: 'Confirme alterar o status',
    message: 'Tem certeza que deseja alterar o status?',
  },
  close: {
    callback: 'update',
    title: 'Confirme fechar chamado',
    message: 'Tem certeza que deseja finalizar o chamado?',
  },
  role: {
    callback: 'update',
    title: 'Confirme alteração de departamento',
    message: 'Tem certeza que deseja alterar o departamento?',
  },
  file: {
    callback: 'deleteFile',
    title: 'Confirme deletar arquivo',
    message: 'Tem certeza que deseja deletar este arquivo?',
  },
};

export const STATUS_OPTIONS = [
  { value: 'new', text: 'Novo' },
  { value: 'open', text: 'Aberto' },
  { value: 'progress', text: 'Em andamento' },
  { value: 'resolved', text: 'Resolvido' },
  { value: 'closed', text: 'Fechado' },
];
export const MODEL_IMAGE = {
  id: null,
  url: null,
  name: null,
  size: null,
  type: null,
  uuid: null,
};

export const MODEL_USER = {
  id: null,
  name: null,
  email: null,
  image: { ...MODEL_IMAGE },
  settings: {
    user_type_id: null,
    role_id: null,
    image_id: null,
  },
};

export const MODEL_TICKET_FILE = {
  id: null,
  user_id: null,
  ticket_id: null,
  file_id: null,
  comment_id: null,
  deleted_at: null,
  file: { ...MODEL_IMAGE },
};

export const MODEL_COMMENT = {
  id: null,
  comment: null,
  ticket_id: null,
  deleted_at: null,
  user: { ...MODEL_USER },
  files: [{ ...MODEL_TICKET_FILE }],
};

export const MODEL = {
  id: null,
  title: null,
  status: 'new',
  user_id: null,
  created_at: new Date(),
  f_created_at: null,
  comment: null,
  type_id: null,
  type: null,
  user: { ...MODEL_USER },
  files: [{ ...MODEL_TICKET_FILE }],
  comments: [{ ...MODEL_COMMENT }],
  project: {
    id: null,
    label: null,
  },
};
